import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { AppRateService } from "../../services/app-rate/app-rate.service";
import { ConfigService } from "../../services/config/config.service";
import { Navigator } from 'src/app/components/menu/navigator';
import { InAppReview } from '@capacitor-community/in-app-review';

@Component({
  selector: 'app-popover-apprate',
  templateUrl: './popover-apprate.component.html',
  styleUrls: ['./popover-apprate.component.scss'],
})
export class PopoveApprateComponent implements OnInit {
  @Input() data: any;
  public commentEnoughLong:boolean = false;
  private inputcomment: AbstractControl;
  public feedbackForm: FormGroup;
  private _iosRateReviewUrl;
  public feedback_window: boolean = true;
  public negative_feedback_window : boolean = false;
  public thank_you_window : boolean = false;
  public feedbackExperienceDlg: any = [];

  constructor(
    private platform: Platform,
    private readonly navigator: Navigator,
    private appRateService: AppRateService,
    public config: ConfigService,
  ){}

  ngOnInit(): void {
    this.feedbackForm = new FormGroup({
      inputcomment: new FormControl("", [Validators.required]),
    });
    this.inputcomment = this.feedbackForm.get("inputcomment");
    this.feedbackExperienceDlg = this.config.getConfig().FEATURE_FEEDBACK_EXPEREIENCE_DLG? 
                                JSON.parse(this.config.getConfig().FEATURE_FEEDBACK_EXPEREIENCE_DLG):
                                [{title1:"Are you enjoying your experience so far?", 
                                  description1:"We’d love to know!", 
                                  yes_label:"Yes!", 
                                  no_label:"No",
                                  yes_icon:"🤗", 
                                  no_icon:"🙁", 
                                  inputplaceholder:"Minimum ten characters", 
                                  title2:"Sorry to hear that!", 
                                  description2:"Please let us know how we can improve your experience.", 
                                  thankyou_title:"Thank you!", 
                                  thankyou_description:"Your feedback has been received!" } ] ;
  }

  public agreeRate(){
    if (this.platform.is("capacitor") && this.platform.is("ios")) {
      this.onClose("yes_btn","positive");
      if(this.config.getConfig().APP_RATE_IOS_URL){
        this._iosRateReviewUrl = this.config.getConfig().APP_RATE_IOS_URL?this.config.getConfig().APP_RATE_IOS_URL:"https://apps.apple.com/ca/app/canplay-ontario-live-casino/id1606024952?action=write-review";
        window.open(this._iosRateReviewUrl, "_system");
      } else {
        InAppReview.requestReview();
      }
    }
  }

  public ignoreRate(){
    this.managePageStatus("negative_feedback_window");
  }

  public managePageStatus(enablePageStatus){
    this.thank_you_window = enablePageStatus=="thank_you_window"?true:false;
    this.feedback_window = enablePageStatus=="feedback_window"?true:false;
    this.negative_feedback_window = enablePageStatus=="negative_feedback_window"?true:false;
  }

  public async sendFeedback(){
    const input = this.emoveEmojis(this.inputcomment.value.trim());
    await this.appRateService.sendFeedback("feedback_sent","negative","ios",input?input:"");
    this.managePageStatus("thank_you_window");
  }

  public async onMaybeLater(){
    this.onClose("maybe_later_btn","negative");
  }

  onClose = (action = "", experience = "") =>{
    if(action!=""){
      this.appRateService.sendFeedback(action,experience,"ios");
    } else if(this.feedback_window){
      
      this.appRateService.sendFeedback("close_btn","negative","ios");
    } else if(this.negative_feedback_window){
      this.appRateService.sendFeedback("close_btn","negative","ios");
    }
    this.navigator.dismissAll();
    this.notificationClose();
  }
  notificationClose() {
    if (this.data.onCloseFunc){
      this.data.onCloseFunc('closeButton');
    }
  }
  emoveEmojis(str) {
    var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    return str.trim().replace(regex, '');
  }
  public onInputFieldChange(input){
    if(this.inputcomment && this.inputcomment.value && this.inputcomment.value.trim().length >= 10 && this.inputcomment.value.trim().length <= 1000){
      this.commentEnoughLong = true;
    } else {
      this.commentEnoughLong = false;
    }
  }

}
